import { defineMessages } from "react-intl";

const GENERIC_ERROR = "generic-error";

const genericErrorMessages = defineMessages({
  genericErrorDescription: {
    id: `${GENERIC_ERROR}.generic-error-description`,
    defaultMessage: "Looks like something went wrong."
  },
  genericErrorMessage: {
    id: `${GENERIC_ERROR}.generic-error-message`,
    defaultMessage:
      "Sorry, we're having trouble connecting with our servers right now. Please try again later or visit our <a>help portal</a>."
  },
  genericErrorTitle: {
    id: `${GENERIC_ERROR}.generic-error-title`,
    defaultMessage: "System error"
  }
});

export default genericErrorMessages;
